// import "bootstrap/dist/css/bootstrap.min.css";
import React, { useCallback, useEffect, useRef, useState } from "react";
import styled, { css } from "styled-components";
import pick from "lodash/pick";

import {
  BookingInfoAppointment,
  MobileBookingInfoAppointment,
} from "@/components/appointment/BookingInfo";
import BookingInfoMobile from "@/components/appointment/BookingInfoMobile";
import DateAndTime, { TimePicker } from "../components/appointment/DateAndTime";
import LocationSelector, {
  getActiveLocationOptions,
  getLocationOptions,
} from "@/components/appointment/LocationSelector";
import {
  appointmentConfirmation,
  appointmentForm,
  brandFetcher,
  deviceFetcher,
  invalidTimeFetcher,
  modelFetcher,
  openTimeFetcher,
  serviceFetcher,
} from "@/components/appointment/modules";

import PaymentSelector from "@/components/appointment/PaymentSelector";
import Steps from "@/components/appointment/Steps";
import ConfirmationModal from "@/components/common/ConfirmationModal";
import Switch from "@/components/common/Switch";
import { FieldWrap } from "@/components/styled/Forms";
import { MaxConstraints } from "@/components/styled/layout";
import { SubTitle } from "@/components/styled/text";
import Button from "@/components/ui/Button";
import { store } from "@/configureStore";
import Form, { useFormContext } from "@/modules/forms";
import { Field } from "@/modules/forms/Blocks";
import { getShopProfileByInformationServer } from "@/service/account/operations";
import media, { OnMobile, useScreenSize, useScreenSizeUpdated } from "@/utils/media";
import PanelToggle from "@/components/appointment/PanelToggle";
import Card from "@/components/shop-profile/Card";
import StepsAppointment from "@/components/StepsAppointment";
import { AppointmentInfo } from "@/components/appointment/AppointmentInfo";
import { UserBookingInfo } from "@/components/appointment/UserBookingInfo";
import { AdditionalBookingInfo } from "@/components/appointment/AdditionalBookingInfo";
import LoadingIcon, { Loading } from "@/components/Loading";
import InfoCard from "@/components/appointment/InfoCard";
import { useFetcher } from "@/modules/dataFetcher";
import api from '@/utils/api';
import { API_URL } from "../constants";
import {
  Spin,
  Row,
  Col,
  Divider,
  notification,
  Modal
} from "antd";
import { appointmentData } from "@/components/appointment/modules";
import SelectRepair, { Back as SelectRepairBack } from "@/components/repairs/SelectRepair";
import AppointmentOverview, { repairInfo } from "@/components/appointment/AppointmentOverview";
import ModelInlineSearch from "@/components/repairs/ModelnlineSearch";
import { useSelector } from "react-redux";
import { createSearchModule } from "@/modules/search";
import ModelInfo from "@/components/repairs/Modelnfo";
import ContactInfo from "@/components/appointment/ContactInfo";
import AppointmentSuccess from "@/components/appointment/AppointmentSuccess";
import { selectRepairModule } from "@/components/repairs/modules";

const MainWrap = styled.div`
  .appointment-card, .max-constraints{
    width: 100%;
  }
  display: flex; 
  max-width: 100%;
  // background-color: #fafafa;
  background-color: #fff;
  padding-bottom: 16px;
  padding-top: 1px;
  margin-bottom: -87px;
 .section-header{
    padding-top: 0 !important;
    padding-bottom: 0 !important;
    margin-top: 0 !important;    
    margin-bottom: 18px !important;  
    min-height: 0 !important;
    height: 32px;  
  }
  .next-button {
    display: flex;
    align-items: center;
    justify-content:center;
    @media (min-width: 768px) {
      margin-top: 24px;
    }
    ${Loading} {
      margin-right: 4px;
    }

    &[disabled] {
      background-color: var(--primary-light-color);
    }
    min-height: 24px;
    height: 32px;
    padding:8px 8px 8px 8px;
    font-weight: 700;
    font-size: 14px;
    line-height: 20px
    border-radius: 20px;
  }

  .booking-mobile-wrapper {
    padding-top: 8px;
    padding-bottom: 8px;
    margin-bottom: 16px;
  }

  .appointment-wrapper {
    margin-top: 24px;
  }
  ${media.tablet`
    > ${MaxConstraints} {
      display: flex;
      justify-content: space-between;
    }
  `}
  ${Card} {
    margin-top: 24px;
    width: 100%;
  }

  .steps-apointment-wrapper {
    margin-top: 16px;
    margin-bottom: 0;
    min-width: 800px;
    @media (max-width: 420px) {
      min-width: 208px;
      max-width: 208px;
    }    

  }

  .page-header-title {
    font-size: 24px;
  }
  .page-header-description {
    margin-bottom: 24px;
  }

  .field-wrap {
    &.bg-white {
      margin: 0 0;
      padding: 0 0;
    }
  }
  ${media.tablet`
  margin-bottom: 12px;

  > ${MaxConstraints} {
    display: flex;
    justify-content: space-between;
  }
  `}
  .step-number {
    font-weight: bold;
    font-size: 24px;
    line-height: 28px;
  }
  .ant-divider {
    display: inline-flex;
    flex:1;
    margin:0;
    padding: 0;
    align: start;
    height: 1px;
    background-color: var(--primary-main-color); 
  }
  .ant-divider-horizontal {
    margin: 32px 0 32px 0;
    padding:0;
    background-color: var(--primary-main-color); 

  }
  .step-divider  .ant-divider  {
    background-color: #DDDDDD; 
    margin-top: 16px;
    margin-bottom: 0;
  }
  .contact-info {
    min-width: 100%;
    width: 100%;
  }
  .go-back {
    margin-top: 26px;
    @media (max-width: 420px) {
    }

    // margin-bottom: 26px;
  }

  .search-models {
    @media (max-width: 420px) {
      margin-top: 28px;
    }
  }
`;

const FormWrap = styled.div`
  max-width: 100%;
  form.fullwidth {
    margin: 0 ;
  }

  ${FieldWrap} {
    width: 100%;
    label {
      color: black;
      font-weight: bold;
    }
  }

  ${media.tablet`
    padding-right: 48px;
    width: 100%;
    .field-wrap {
      margin: 0 !important;
      padding: 0  !important;
    }

    ${FieldWrap} {
      label {
        display: none;
      }
    }
  `}
  .ant-input {
    min-height: 47px;
    border: 1px solid #E4E4E4;
    border-radius: 25px;
    font-weight: 500;
    font-size: 16px;
    line-height: 16px;
    color: #707070;
  }
`;


const DetailsForm = styled.div`
  // display:flex;
  margin: 0;
  padding: 0;
  width: 100%;
  min-width: 100%;

  ${FieldWrap} {
    // padding: 5px 10px;

    input {
      width: 100%;
    }
  }
`;

function ConnectedDateAndTime() {
  const { state } = useFormContext();
  return <DateAndTime required={state?.values?.location === "in-store"} open={true} />;
}

const StepsDescription = [
  {
    title: "Select Device & Reparation",
    // description: "Select model, brand, device, repair",
  },
  {
    title: "Afspraak gegevens",
    description: "Kies het moment dat jou uitkomt",
  },
  {
    title: "Jouw gegevens",
    description: "Laat weten hoe de reparateur je kan bereiken",
  }
];

const StyledBox = styled.div`
`

function PageTitle({ step }) {
  const description = StepsDescription[step]?.description
  return (
    <>
      <div className="text-green none md:block step-number">0{step + 1}</div>
      <div className="page-header-title font-bold">
        {StepsDescription[step]?.title}
      </div>
    </>
  );
}
const MobileToolbar = styled.div`
  position: fixed;
  z-index: 999;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 8px;
  background-color: #fff;
  box-shadow: 0 0 27px rgb(0 0 0 / 30%);
  ${media.tablet`
    position: static;
    // background-color: transparent;
    box-shadow: none;
    padding: 0;
    margin-top: 32px;
  `}
`;
const searchRepairsModule = createSearchModule('searchRepairs')
const NextButton = ({ onClick, step, loading, disabled }) => {
  const { selectedItem: selectedRepair } = useSelector(searchRepairsModule.selector)
  const { color } = useSelector(appointmentData.selector)
  const { rmodel } = useSelector(repairInfo)
  const validator = appointmentForm.validator;
  const { state } = useFormContext();
  const [isDisabled, setDisabled] = useState(false);
  const buttonRef = useRef(null);
  const isMobile = useScreenSizeUpdated() === 'mobile'
  useEffect(() => {
    if (step === 0) {
      if (selectedRepair) {
        let disabled = false
        if (rmodel && rmodel.colors && rmodel.colors.length > 0 && !color) {
          disabled = true
        }
        setDisabled(disabled)
        if (step === 0 && isMobile) {
          buttonRef.current?.scrollIntoView({ behavior: 'smooth' });
        }
      } else {
        setDisabled(true)
      }
    }
  }, [selectedRepair, color])
  useEffect(() => {
    const runValidate = async () => {
      try {
        if (step < 2) {
          await Promise.all(
            ["time"].map((field) => validator.validateAt(field, state.values))
          );
        } else if (step === 2) {
          await Promise.all(
            [
              "time",
              "email",
              "name",
              "tel",
              "enquiry",
              "address",
              "city",
              "zip",
            ].map((field) => validator.validateAt(field, state.values))
          );
        }
        setDisabled(false);
      } catch (e) {
        // console.log(e);
        setDisabled(true);
      }
    };
    runValidate();
  }, [state, step]);

  const handleClick = (e) => {
    e.preventDefault();
    e.stopPropagation();
    onClick && onClick();
  };
  return (
    <Button
      className="next-button"
      disabled={disabled || isDisabled}
      onClick={handleClick}
      ref={buttonRef}
    >
      {loading && <LoadingIcon size="20px" thick="2px"></LoadingIcon>}
      {step < 2 ? "Volgende Stap" : "Bevestig"}
    </Button>
  );
};

const StyledSuccessModal = styled(Modal)`
    .ant-modal-content {
      @media (min-width: 768px) {
          padding: 40px;
      }
      box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
      border-radius: 16px;
      padding:0;
      margin:0;
  }
`
const SuccessModal = ({ shop, redirect_url, appointmentId, show }) => {
  const [visible, setVisible] = useState(false)
  useEffect(() => {
    setVisible(show)
  }, [show])
  const handleCancel = () => {
    setVisible(false)
  }
  return <StyledSuccessModal
    visible={visible}
    onCancel={handleCancel}
    footer={null}
    className="success-modal"
  >
    <Row type="flex">
      <Col span={24} >
        <AppointmentSuccess shop={shop} appointmentId={appointmentId} redirect_url={redirect_url} />
      </Col>
    </Row>
  </StyledSuccessModal>

}
export default function AppointmentPage({ shop, redirect_url }) {
  const [step, updateStep] = useState(0);
  const [loading, setLoading] = useState(false);
  const { device, brand, model, reparation, isGoBack } = useSelector(appointmentData.paramsSelector)
  const { step: selectRepairStep } = useSelector(selectRepairModule.selector)
  const [appointmentResponse, setAppointmentResponse] = useState()
  const showReparatieList = selectRepairStep && selectRepairStep === 4;
  const locationRef = useRef(null);
  const contactInfoRef = useRef(null);
  const isMobile = useScreenSizeUpdated() == 'mobile';

  useEffect(() => {
    device && deviceFetcher.fetch();
  }, [device])
  useEffect(() => {
    brand && brandFetcher.fetch();
  }, [brand])
  useEffect(() => {
    model && modelFetcher.fetch();
  }, [model])
  useEffect(() => {
    reparation && serviceFetcher.fetch();
  }, [reparation])

  useEffect(() => {
    if (isGoBack && step > 0) {
      updateStep(step - 1)
      appointmentData.updateParams({ isGoBack: false })
    }
  }, [isGoBack])
  useEffect(() => {
    if (step < 2) {
      setAppointmentResponse(null)
    }
  }, [step]);
  useEffect(() => {
    if (isMobile) {
      if (step === 1) {
        console.log('location scroll...')
        let selectorRef = document.querySelector('.location-selector');
        if (!selectorRef) {
          selectorRef = document.querySelector('.date-time-selector');
        }
        console.log(selectorRef)

        selectorRef && selectorRef.scrollIntoView({ behavior: 'smooth' });
        // locationRef.current?.scrollIntoView({ behavior: 'smooth' });
      }
      if (step === 2) {
        console.log('contact info scroll...')
        const contactInfoRef = document.querySelector('.contact-info');
        if (contactInfoRef) {
          console.log(contactInfoRef)
          contactInfoRef.scrollIntoView({ behavior: 'smooth' });
        }
        // contactInfoRef.current?.scrollIntoView({ behavior: 'smooth' });
      }
    }

  }, [step, isMobile])
  useEffect(() => {
    async function loadData() {
      // console.log(`Appointment step ${step}...`)
      await appointmentForm.actions.initialize({ shop });
    }

    loadData();
  }, [shop]);
  useEffect(() => {

    if (step === 1) {
      async function loadData() {
        if (appointmentData.isReparationSelected()) {
          await appointmentForm.actions.initialize({ shop });
          invalidTimeFetcher.fetch();
          openTimeFetcher.fetch();
        } else {
          updateStep(0)
        }
      }
      loadData()
    }
  }, [step])

  const onNext = async () => {
    const fieldsToValidate = {
      1: ["time", "service"],
      2: ["name", "email", "tel", "address", "city", "zip"],
    };

    if (Object.keys(fieldsToValidate).includes(`${step}`)) {
      await appointmentForm.actions.validateField({
        name: fieldsToValidate[step],
      });
      const { errors } = appointmentForm.state;
      if (Object.keys(pick(errors, fieldsToValidate[step])).length) {
        appointmentConfirmation.actions.open({
          type: "warning",
          message:
            "Je lijkt niet alle informatie te hebben ingevuld, even checken? ",
          description:
            "We hebben al je informatie nodig om een afspraak te maken",
          buttonLabel: "Probeer het nog een keer",
        });

        return;
      }
    }

    if (step === 2) {
      setLoading(true);
      const appointmentResponse = await appointmentForm.actions.submit();
      setAppointmentResponse(appointmentResponse)
      setLoading(false)
      // updateStep(0)
      // appointmentData.updateParams({ shop: appointmentData.getParams()?.shop })
    }
    if (step < 2) {
      updateStep((state) => state + 1);
    }
  };


  const activeLocationOptions = getActiveLocationOptions(shop);
  const mainContentSpan = showReparatieList ? 14 : 24
  const backTitle = step > 0 && StepsDescription[step].title
  const showInlineSearch = !isMobile || selectRepairStep < 4
  return (
    <MainWrap>
      <MaxConstraints>

        <Row type="flex" justify="center" align="center">
          <Col span={24}>
            <Card className='appointment-card'>
              <Row type="flex" justify="center" align="center">

                {showInlineSearch &&
                  <Col span={24} style={{ justifySelf: "center", justifyContent: 'center', justifyItems: 'center', display: 'flex' }}>
                    <ModelInlineSearch
                      modelsFetcher={appointmentData.fetchInlineModels}
                      onSelect={() => {
                        updateStep(0)
                      }} />
                  </Col>
                }
                <Col span={24} style={{ display: "flex", justifyContent: "center" }}>
                  <div className="steps-apointment-wrapper">
                    <StepsAppointment current={step}></StepsAppointment>
                  </div>
                </Col>
                {/* {!isMobile && */}
                <Col span={24} className="step-divider">
                  <Divider orientation="right" />
                </Col>
                {/* } */}
              </Row>

              <Form module={appointmentForm}>
                <Row type="flex" gutter={16}>
                  <Col span={isMobile ? 24 : mainContentSpan} >
                    <Row type="flex" gutter={0}>
                      <Col span={24} className="go-back">
                        <SelectRepairBack module={appointmentData} title={backTitle} />
                      </Col>
                      {/* <Col span={24}>
                        <PageTitle step={step}></PageTitle>
                      </Col> */}
                      {/* {!isMobile && selectRepairStep === 4 &&
                        <Col span={24}>
                          <ModelInfo selector={repairInfo} />
                        </Col>
                      } */}
                    </Row>

                    <Switch value={step}>
                      <Switch.Case value={0}>
                        <SelectRepair
                          dataModule={appointmentData}
                          onFinish={() => {
                            console.log('finish...')
                            updateStep(1);
                          }}
                          modelSelector={repairInfo}
                        />

                      </Switch.Case>
                      <Switch.Case value={1}>
                        <FormWrap>
                          {activeLocationOptions.length > 1 && (
                            <>
                              <div className="field-wrap bg-white location-selector">
                                <Field
                                  name="location"
                                  as={LocationSelector}
                                  options={getLocationOptions(shop)}
                                  open={true}

                                />
                              </div>
                            </>
                          )}
                          <div className="field-wrap date-time-selector">
                            <ConnectedDateAndTime />
                          </div>
                          <div className="field-wrap bg-white">
                            <Field name="time" as={TimePicker} open={true} />
                          </div>
                        </FormWrap>
                      </Switch.Case>
                      <Switch.Case value={2}>
                        <div className="flex contact-info">
                          <FormWrap>
                            <DetailsForm>
                              <ContactInfo appointmentForm={appointmentForm} className="contact-info" />
                            </DetailsForm>
                          </FormWrap>
                        </div>
                      </Switch.Case>
                    </Switch>
                  </Col>
                  {showReparatieList &&
                    <Col span={isMobile ? 24 : 24 - mainContentSpan}>
                      <Row type="flex" gutter={0}>
                        <Col span={24}>
                          <AppointmentOverview />
                        </Col>
                        <Col span={24} style={{ display: "flex", justifyContent: "flex-end", align: "center" }}>
                          {isMobile && step > 0 ? <MobileToolbar>
                            <Row type="flex" style={{ minWidth: "100%", justifyContent: "flex-end" }}>
                              <Col>
                                <NextButton
                                  disabled={step === 3 ? loading : undefined}
                                  loading={step === 3 ? loading : undefined}
                                  step={step}
                                  onClick={onNext}
                                  style={{ marginLeft: "auto" }}
                                ></NextButton>

                              </Col>
                            </Row>

                          </MobileToolbar>
                            :
                            <NextButton
                              disabled={step === 3 ? loading : undefined}
                              loading={step === 3 ? loading : undefined}
                              step={step}
                              onClick={onNext}
                            ></NextButton>
                          }
                        </Col>
                      </Row>
                    </Col>
                  }
                </Row>
              </Form>
              {appointmentResponse && <SuccessModal shop={shop} appointmentId={appointmentResponse.id} show={true} redirect_url={redirect_url} />}
              <ConfirmationModal module={appointmentConfirmation} />
            </Card>
          </Col>
        </Row>
      </MaxConstraints>

    </MainWrap>
  );
}

const Appointment = ({ settings, redirect_url }) => {
  const [shop, setShop] = useState()
  const [loading, setLoading] = useState(true)
  useEffect(() => {
    async function loadData() {
      const shop = await appointmentData.fetchShop(settings?.shopName)
      let params = { shop }
      appointmentData.updateParams(params)
      setShop(shop)
      setLoading(false)
    }
    loadData()
  }, [])

  if (loading) {
    return <Spin />
  }
  return shop && <AppointmentPage shop={shop} redirect_url={redirect_url} />
}

export { Appointment };